import { Pipe, PipeTransform } from 'angular-ts-decorators';

export type SignFilter = (input: number, fractionSize: number) => string;

interface ISign {
  transform: SignFilter;
}

/**
 * Filter in the coreModule.
 * Has the same API as the angular 'number' filter with one addition:
 * adds plus sign to absolute positive values, useful when negative values are valid input
 * @param {number} input
 * @param {number} fractionSize - integer
 * @return {string}
 */
@Pipe({ name: 'sign' })
export class SignPipe implements PipeTransform, ISign {
  constructor(private numberFilter: ng.IFilterNumber) {
    'ngInject';
  }

  public transform(input: number, fractionSize: number): string {
    if (angular.isUndefined(fractionSize)) {
      fractionSize = 2;
    }

    if (!angular.isNumber(input)) {
      return;
    }

    switch (Math.sign(input)) {
      case -1:
      case 0:
        return this.numberFilter(input, fractionSize);
      case 1:
        return `+${this.numberFilter(input, fractionSize)}`;
    }
  }
}
